import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_WorkspaceSchedulationTable = _resolveComponent("WorkspaceSchedulationTable")
  const _component_WorkspaceSchedulationOldSchedulationsDialog = _resolveComponent("WorkspaceSchedulationOldSchedulationsDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "showSidenavIcon",
          icon: "fas fa-bars",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMenu')))
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.schedulation.title')), 1)
      ]),
      end: _withCtx(() => [
        (_ctx.canRunScheduledExecutions)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "kn-button p-button-text p-button-rounded",
              onClick: _ctx.runAllSchedulations
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.run')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_WorkspaceSchedulationTable, {
      class: "overflow p-m-2",
      propJobs: _ctx.jobs,
      onRunSchedulationClick: _ctx.runSingleSchedulation,
      onSchedulationsSelected: _ctx.setSelectedSchedulations,
      onViewOldSchedulationsClick: _ctx.viewOldSchedulations
    }, null, 8, ["propJobs", "onRunSchedulationClick", "onSchedulationsSelected", "onViewOldSchedulationsClick"]),
    _createVNode(_component_WorkspaceSchedulationOldSchedulationsDialog, {
      visible: _ctx.schedulationsDialogVisible,
      selectedJob: _ctx.selectedJob as any,
      onClose: _ctx.closeOldSchedulationsDialog
    }, null, 8, ["visible", "selectedJob", "onClose"])
  ], 64))
}